import * as React from "react";
const SVGComponent = (props) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect opacity="0.796573" x="0.0976562" y="0.84375" width="19" height="3" rx="1.5" fill="#064267" />
        <rect opacity="0.796573" x="5.55859" y="9.30469" width="13.5385" height="2.53846" rx="1.26923" fill="#064267" />
        <rect opacity="0.796573" x="10.6367" y="16.7656" width="8.46154" height="2.53846" rx="1.26923" fill="#064267" />
    </svg>

);
export default SVGComponent;
